import { gql } from '@apollo/client';

export const CURRENT_MAINTENANCE = gql`
  query CurrentMaintenance {
    currentMaintenance {
      id
      title
      description
      startAt
      endAt
      status
    }
  }
`;
